import React, { useEffect } from "react";
import ProductTable from "./products/components/ProductTable";
import EditProduct from "./EditProduct";
import DeleteProducts from "./products/deleteproduct/DeleteProducts";
import EditMenu from "./EditMenu";
import AddProductModal from "./products/components/AddProductModal";
import ProductToolbar from "./products/components/ProductToolbar";
import { useProductHandlers } from "./products/hooks/useProductHandlers";
// @ts-ignore: allow side-effect CSS import without module declarations
import "./Edit.css";
import { PageTitle } from "src/shared/PageTitle";
import LoadingScreen from "src/shared/components/LoadingScreen";
import { useUser } from "src/shared/context/UserContext";
import { pageTitle } from "src/shared/utils/brand";
import { useUserTheme } from "src/shared/utils/useUserTheme";

const ProductsPage: React.FC = () => {
  const { user } = useUser();
  const { sidebarThemeClass } = useUserTheme();
  
  useEffect(() => {
    document.title = pageTitle("Products › Settings");
  }, []);
  const businessType = user?.businessType ?? "";

  const { products, categories, staff, totalRecords, loading, selectedProduct, showAddModal, showEditModal, showDeleteModal, searchTerm, categoryFilter,
     showDeletedProducts, page, rowsPerPage, refetchProducts, setShowAddModal, handleAddProduct, handleEditProduct, handleDeleteProduct, 
     handleCloseModals, handleCategoryChange, handleToggleDeleted, handleSearchChange, handlePageChange, handleRowsPerPageChange } = useProductHandlers({ businessType });

  const menu = { Product: "product" };

  return (
    <div className="p-1">
      <div className={`flex flex-col w-full h-[91vh] shadow-inner rounded-lg items-center ${sidebarThemeClass} overflow-hidden`}>
        <PageTitle title="- Settings › Products" />
        <EditMenu editmenu={menu} />

        <ProductToolbar
          categories={categories}
          categoryFilter={categoryFilter}
          onCategoryChange={handleCategoryChange}
          showDeletedProducts={showDeletedProducts}
          onToggleDeleted={handleToggleDeleted}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onAddProduct={() => setShowAddModal(true)}
        />

        <div className="w-[96%] flex justify-center h-auto overflow-x-hidden text-white ">
          <ProductTable
            products={products}
            categories={categories}
            loading={loading}
            page={page}
            rowsPerPage={rowsPerPage}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onEdit={handleEditProduct}
            onDelete={handleDeleteProduct}
            showDeletedProducts={showDeletedProducts}
          />
        </div>

        <AddProductModal
          open={showAddModal}
          onClose={handleCloseModals}
          onSubmit={handleAddProduct}
          categories={categories}
          staffMembers={staff}
          businessType={businessType}
        />

        {showEditModal && selectedProduct && (
          <EditProduct
            open={showEditModal}
            product={selectedProduct}
            categories={categories}
            staffMembers={staff}
            businessType={businessType}
            onClose={handleCloseModals}
            onUpdate={refetchProducts}
          />
        )}

        {showDeleteModal && selectedProduct && <DeleteProducts product={selectedProduct} onClose={handleCloseModals} onDelete={refetchProducts} />}
      </div>
      {loading && <LoadingScreen />}
    </div>
  );
};

export default ProductsPage;
